export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_TOKEN = 'UPDATE_TOKEN';

// Aqui são declarados todos os tipos de mutations no store



// WEBPACK FOOTER //
// ./src/store/MutationTypes.js